import * as React from 'react';
import type { MenuButtonProps } from '../../../MenuButton.types';
import BaseButton from './BaseButton';
import skinsStyle from './styles/RibbonsMenuButtonNSkin.scss';

const RibbonsMenuButtonNSkin: React.FC<MenuButtonProps> = props => {
  return (
    <BaseButton
      {...props}
      skinsStyle={skinsStyle}
      skin="RibbonsMenuButtonNSkin"
    />
  );
};

export default RibbonsMenuButtonNSkin;
